import {
  UPLOAD_BANNER,
  GET_BANNERS,
  EDIT_BANNERS,
  COUNT_BANNERS,
  TOTAL_PAGES_BANNERS,
  PAGINATION_PARAMS_BANNERS
} from "./actionType";

const initialState = {
  data: null,
  paginationParams: {
    page: 0,
    pageSize: 10
  },
  totalPages: null,
  count: null
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_BANNER:
      return {
        ...state,
        data: payload
      };
    case GET_BANNERS:
      return {
        ...state,
        data: payload
      };
    case EDIT_BANNERS:
      return {
        ...state,
        data: payload
      };
    case TOTAL_PAGES_BANNERS:
      return {
        ...state,
        totalPages: payload
      };
    case COUNT_BANNERS:
      return {
        ...state,
        count: payload
      };
    case PAGINATION_PARAMS_BANNERS:
      return {
        ...state,
        paginationParams: payload
      };
    default:
      return {
        ...state
      };
  }
};
